import { render, staticRenderFns } from "./strippay.vue?vue&type=template&id=5c755cb3&scoped=true"
import script from "./strippay.vue?vue&type=script&lang=js"
export * from "./strippay.vue?vue&type=script&lang=js"
import style0 from "./strippay.vue?vue&type=style&index=0&id=5c755cb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c755cb3",
  null
  
)

export default component.exports